import getRootVdirName from './getRootVdirName';
import { getHostLocation } from './hostLocation';
import getScopedPath from './getScopedPath';

let basePath: string;

/**
 * Gives the base path with the following format: mail/ or mail/0/
 */
export default function getBasePath() {
    if (!basePath) {
        const vdir = getRootVdirName(getHostLocation());
        basePath = getScopedPath('/' + vdir, getHostLocation().pathname.replace(/\/$/, '')) + '/';
        basePath = basePath.replace(/^\//, '');
    }

    return basePath;
}
